import { render, staticRenderFns } from "./accessories-list.vue?vue&type=template&id=7d873acf&scoped=true&"
import script from "./accessories-list.vue?vue&type=script&lang=js&"
export * from "./accessories-list.vue?vue&type=script&lang=js&"
import style0 from "./accessories-list.vue?vue&type=style&index=0&id=7d873acf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d873acf",
  null
  
)

export default component.exports